// @ts-nocheck
import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

// react-router-dom components

// @mui material components
import Grid from "@mui/material/Grid";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import AddIcon from '@mui/icons-material/Add';

// Material Dashboard 2 React components
import MDTablePagination from "../../components/MDTablePagination";
import MDInputTimeout from "../../components/MDInputTimeout";
import MDBox from "../../components/MDBox";
import MDFab from "../../components/MDFab";
import MDTypography from "../../components/MDTypography";
import MDActionMenu from "../../components/MDActionMenu";
import MDAlertDialog from "../../components/MDAlertDialog";

import { deleteById as deleteShipperById, getAll as getAllShipper } from "../../reducers/shipper";
import { getCountryName, getStateName } from "../../helpers/country-state";
import { hasAccess } from "../../helpers/access";
import ShipperForm from "./ShipperForm";


function Shipper() {
  let dispatch = useDispatch()
  const user = useSelector(state => state.auth.user)
  const data = useSelector(state => state.shipper.list)

  const [loading, setLoading] = useState(false)
  const [search, setSearch] = useState("")
  const [openForm, setOpenForm] = useState(null)
  const [openDelete, setOpenDelete] = useState(null)

  const { limit, currentPage } = data.paginator
  const getData = useCallback((page = currentPage, newLimit = limit) => {
    const params = {
      q: search,
      limit: newLimit,
      page,
    }
    setLoading(true)
    dispatch(getAllShipper(params))
    setLoading(false)
  }, [search, limit, currentPage, dispatch])
  useEffect(() => {
    const params = {
      q: search,
      limit,
      page: 1,
    }
    setLoading(true)
    dispatch(getAllShipper(params))
    setLoading(false)
  }, [search, limit, dispatch])

  const handleCreate = () => {
    getData()
  }

  const handleChangePaginator = (paginator) => {
    getData(paginator.currentPage, paginator.limit)
  }
  const handleClickUpdate = (data) => () => {
    setOpenForm(data)
  }
  const handleClickDelete = (data) => () => {
    setOpenDelete(data)
  }
  const handleSubmitDelete = () => {
    if (openDelete && openDelete.id) {
      return dispatch(deleteShipperById(openDelete.id))
    }
    return null
  }

  return (
    <MDBox p={2} bgColor="white">
      <Grid container spacing={1}>
        <Grid item xs={12} sm={12} md={6} lg={4} xl={3}>
          <MDInputTimeout disabled={loading} value={search} onChange={(e) => setSearch(e.target.value)} label="Search" fullWidth />
        </Grid>
        <Grid item xs={12}>
          <MDTablePagination paginator={data.paginator} onChange={handleChangePaginator}>
            <Table stickyHeader sx={{ minWidth: 650 }}>
              <TableHead>
                <TableRow>
                  <TableCell>
                    <MDTypography variant="button" fontWeight="bold">Name</MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography variant="button" fontWeight="bold">Address</MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography variant="button" fontWeight="bold">City</MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography variant="button" fontWeight="bold">District</MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography variant="button" fontWeight="bold">State</MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography variant="button" fontWeight="bold">Country</MDTypography>
                  </TableCell>
                  <TableCell>
                    <MDTypography variant="button" fontWeight="bold">Postal Code</MDTypography>
                  </TableCell>
                  {hasAccess(["shipper.update", "shipper.delete"], user) && (
                    <TableCell align="right" />
                  )}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.data.map(d => {
                  return (
                    <TableRow key={`data-${d.id}`}>
                      <TableCell>
                        <MDTypography variant="body2">{d.name || ""}</MDTypography>
                      </TableCell>
                      <TableCell>
                        <MDTypography variant="body2">{d.addressFieldOne || ""}</MDTypography>
                        <MDTypography variant="body2">{d.addressFieldTwo || ""}</MDTypography>
                      </TableCell>
                      <TableCell>
                        <MDTypography variant="body2">{d.city || ""}</MDTypography>
                      </TableCell>
                      <TableCell>
                        <MDTypography variant="body2">{d.district || ""}</MDTypography>
                      </TableCell>
                      <TableCell>
                        <MDTypography variant="body2">{getStateName(d.country, d.state) || ""}</MDTypography>
                      </TableCell>
                      <TableCell>
                        <MDTypography variant="body2">{getCountryName(d.country) || ""}</MDTypography>
                      </TableCell>
                      <TableCell>
                        <MDTypography variant="body2">{d.postalCode || ""}</MDTypography>
                      </TableCell>
                      {hasAccess(["shipper.update", "shipper.delete"], user) && (
                        <TableCell align="right" padding="checkbox" size="small">
                          <MDActionMenu
                            handleUpdate={hasAccess(["shipper.update"], user) ? handleClickUpdate(d) : null}
                            handleDelete={hasAccess(["shipper.delete"], user) ? handleClickDelete(d) : null}
                          />
                        </TableCell>
                      )}
                    </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </MDTablePagination>
          {hasAccess(["shipper.create"], user) && (
            <MDFab color="primary" onClick={() => setOpenForm({})}>
              <AddIcon />
            </MDFab>
          )}
          {openForm !== null && (
            <ShipperForm data={openForm} onClose={() => setOpenForm(null)} onCreate={handleCreate} />
          )}
          {openDelete && (
            <MDAlertDialog onClose={() => setOpenDelete(null)} title="Delete Shipper?" content={
              <>
                <MDBox>
                  <MDTypography variant="h5">{openDelete.name || ""}</MDTypography>
                  <MDTypography variant="body2">will be deleted permanently. You need to reassign shipper to any active packing lists that use this.</MDTypography>
                </MDBox>
              </>
            }
              onSubmit={handleSubmitDelete}
              submitText="Delete"
            />
          )}
        </Grid>
      </Grid>
    </MDBox>
  );
}

Shipper.propTypes = {
}

export default Shipper